export const localStorageItemNames = {
  user_token: "hyundai_admin_user_token",
  userID: "hyundai_admin_user_id",
  userTypeId: "userTypeId",
  name: "name",
  userTypeName: "userTypeName",
  type: "type",
};
